module.exports = __webpack_public_path__ + "img/1-20-5.35a5c603.png";